export default "__VITE_ASSET__CtJdcSsk__"